import { adModal, adSlide } from "@modules/single-page/gallery/templates"
import type Swiper from "swiper"
import type { SwiperContainer, SwiperSlide } from "swiper/element"

export function initializeGalleryAds(swiperContainer: SwiperContainer, swiper: Swiper): void {
    if (userData.isLoggedIn && userData.hasAdFree) {
        return
    }

    if (SiteInfo.isMobileVersion) {
        addClosingAdListener(swiperContainer)
        return
    }

    addAdSlides(swiper)
    updateGalleryThumbnailSlideIndices()
}

export function initializeThumbnailAds(swiper: Swiper): void {
    if (userData.isLoggedIn && userData.hasAdFree) {
        return
    }

    if (SiteInfo.isMobileVersion) {
        return
    }

    addHiddenThumbnailSlidesToFixSlideHighlighting(swiper)
}

function addClosingAdListener(swiperContainer: SwiperContainer): void {
    $(swiperContainer)
        .closest(".modal")
        .on("hide.bs.modal", (): void => {
            injectClosingGalleryAd()
        })
}

const injectionIndex: number = 2

function addAdSlides(swiper: Swiper): void {
    const swiperContainer = swiper.el as HTMLElement
    swiperContainer.dataset.originalSlideCount = String(swiper.slides.length)

    if (swiper.slides.length > 2) {
        const slide1: SwiperSlide = createAdSlide()
        swiper.addSlide(injectionIndex, slide1)
    }

    const slide2 = createAdSlide()
    swiper.addSlide(swiper.slides.length, slide2)

    swiper.update()
}

function createAdSlide(): SwiperSlide {
    const slideElement: SwiperSlide = document.createElement("swiper-slide")
    slideElement.appendChild(adSlide?.cloneNode(true) as HTMLElement)
    const firstChild = slideElement.firstChild

    if (firstChild instanceof HTMLElement) {
        firstChild.dataset.galleryText = "Anzeige"
    }

    const solAdLinkElement: HTMLAnchorElement | null = slideElement.querySelector(".sol-ads-link")

    if (solAdLinkElement) {
        solAdLinkElement.href = userData.isAgeVerified ? "https://www.exoclick.com/de/" : "https://www.solads.media/"
        solAdLinkElement.innerHTML = userData.isAgeVerified ? "ExoClick" : "SolAds"
    }
    return slideElement
}

function updateGalleryThumbnailSlideIndices(): void {
    const indexThumbnails: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>(".gallery_item[data-index]")

    for (const thumbnail of indexThumbnails) {
        const index: number = Number.parseInt(thumbnail.dataset.index || "", 10) || 0

        if (index >= injectionIndex) {
            thumbnail.dataset.index = (index + 1).toString()
        }
    }
}

function addHiddenThumbnailSlidesToFixSlideHighlighting(swiper: Swiper): void {
    const slide1: SwiperSlide = document.createElement("swiper-slide")
    slide1.style.visibility = "hidden"
    slide1.style.width = "0"

    const slide2: SwiperSlide = document.createElement("swiper-slide")
    slide2.style.visibility = "hidden"
    slide2.style.width = "0"

    swiper.addSlide(injectionIndex, slide1)
    swiper.addSlide(swiper.slides.length, slide2)

    swiper.update()
}

function injectClosingGalleryAd(): void {
    const galleryInject = adModal?.cloneNode(true) as HTMLElement

    if (galleryInject !== null) {
        document.querySelector(".vp")?.appendChild(galleryInject)
    }
}
